// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/background.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body,html {
  font-family: 'Monaco', monospace;
}

h1{
  font-size: 2.75vh;
	color: #000000;
	text-transform: uppercase;
	margin: 10px 0;
}

h2{
  font-size: 2.25vh;
	color: #000000;
	text-transform: uppercase;
	margin: 10px 0;
}

h3{
  font-size: 2vh;
	color: #ffffff;
	margin: 10px 0;
}

h4{
  font-size: 2.25vh;
	color: #ffffff;
	text-transform: uppercase;
	margin: 10px 0;
}


.tittle{
  font-weight: bold;
}

.general-page{
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat bottom right / auto 40vh, rgb(232, 231, 227);
  width: 100%;
  min-height: 100vh;
  align-items: center;
  justify-content: center;
  font-family: 'Monaco', monospace;
  position: absolute;
  margin: 0;
  padding: 0;
  overflow: auto;
  z-index: 0;
}

.general-container {
  width: 30%;
  margin: 5% auto;
  padding: 30px; 
  background-color: transparent;
  border: none;
  text-align: center;
}

.general-input {
  box-sizing: border-box; 
  width: 100%; 
  padding: 15px;
  margin: 10px 0; 
  background-color: #ffffff;
  border-radius: 10px; 
  font-family: 'Monaco', monospace;
  color: rgb(0, 0, 0);
  border-color: transparent;
}

.general-input-50 {
  box-sizing: border-box;
  width: 45%; 
  margin-right: 5%;
  padding: 15px;
  margin: 10px; 
  background-color: rgba(255, 255, 255,1.0);       
  border: 0px solid #a2d2ff;
  border-radius: 10px; 
  font-family: 'Monaco', monospace;
}

.form-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.full-width {
  grid-column: 1 / -1;
}

.input-group {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.general-button {
  width: 80%;
  padding: 15px;
  margin: 10px auto;
  background-color: #b7f88c;
  color: black;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s ease; 
  font-family: 'Monaco', monospace;
}

.general-button:hover {
  background-color: #91c072;
}

.secondary-button {
  background-color: #54f0ed;
}

.secondary-button:hover {
  background-color: #55c9c4;
}

.fastSettings-button {
  background-color: #ff8a99;
}

.fastSettings-button:hover {
  background-color: #bf5a67;
}

.edit-button {
  background-color: #ffc445;
}

.edit-button:hover {
  background-color: #cca249;
}

.delete-button {
  background-color: #ff2e2e;
}

.delete-button:hover {
  background-color: #d34b4b;
}

.back-button{
  padding: 1.5% 1.5%; 
  background-color: #ff8a99; 
  color: black; 
  border: none;
  border-radius: 10px;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s ease;
}

.back-button:hover {
  background-color: #bf5a67;
}

.header-button {
  padding: 2%;
  background-color: #b7f88c;
  color: black; 
  border: none;
  border-radius: 10px;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s ease;
  font-family: 'Monaco', monospace
}

.header-button:hover {
  background-color: #91c072;
}

.general-error {
  color: #ff6961;
  margin-bottom: 10px;
  font-weight: bold;
}

.space-info {
  background-color: #555;
  color: white;
  margin-top: 2.5%;
  padding: 1% 0.5% 0.5% 1%;
}

.space-info-big {
  background-color: #333;
  color: white;
  padding-top: 1%;
  padding-bottom: 1%;
  margin-top: 2.5%;
  margin-bottom: 5%;
  padding: 1% 0.5% 0.5% 1%;
  border-radius: 8px;
}

.form-group {
  position: relative;
  margin-bottom: 20px;
}

.password-toggle-button {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  background: none;
  border: none;
  padding: 5px;
  cursor: pointer;
}

.little-button{
  width: 1%;
  margin: 1%;
  min-width: 50px;
}

.fi-rr-pencil {
  font-size: small;
}

.fi-rr-trash {
  font-size: small;
}

.fi-rr-eye {
  font-size: small;
}

.soft-background{
  background-color: rgb(0, 0, 0, 0.0);
}

.mid-button{
  width: 40%;
  margin: 1%;
}

.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input { 
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
  border-radius: 34px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: .4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:checked + .slider:before {
  transform: translateX(26px);
}

.help-info {
  background-color: #333;
  color: #fff;
  padding: 20px;
  border-radius: 8px;
  overflow-x: auto;
  text-align: center;
}

.help-container {
  background-color: #444;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 2%;
}

.sm-space-info2.centered-space-info {
  width: 100%;
}

.content2 {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
}

.vertical-stack-content {
    display: flex;
    flex-direction: column;
    min-height: 60vh;
    justify-content: space-between;
    flex: 1 1;
}

.bottom-center {
    display: flex;
    justify-content: center;
    margin-top: auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/styles/General.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;CAClB,cAAc;CACd,yBAAyB;CACzB,cAAc;AACf;;AAEA;EACE,iBAAiB;CAClB,cAAc;CACd,yBAAyB;CACzB,cAAc;AACf;;AAEA;EACE,cAAc;CACf,cAAc;CACd,cAAc;AACf;;AAEA;EACE,iBAAiB;CAClB,cAAc;CACd,yBAAyB;CACzB,cAAc;AACf;;;AAGA;EACE,iBAAiB;AACnB;;AAEA;EACE,0GAAmG;EACnG,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,eAAe;EACf,aAAa;EACb,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,yCAAyC;EACzC,yBAAyB;EACzB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,wCAAwC;EACxC,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,wCAAwC;EACxC,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,wCAAwC;EACxC,sCAAsC;EACtC;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,8BAA8B;IAC9B,SAAO;AACX;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB","sourcesContent":["body,html {\n  font-family: 'Monaco', monospace;\n}\n\nh1{\n  font-size: 2.75vh;\n\tcolor: #000000;\n\ttext-transform: uppercase;\n\tmargin: 10px 0;\n}\n\nh2{\n  font-size: 2.25vh;\n\tcolor: #000000;\n\ttext-transform: uppercase;\n\tmargin: 10px 0;\n}\n\nh3{\n  font-size: 2vh;\n\tcolor: #ffffff;\n\tmargin: 10px 0;\n}\n\nh4{\n  font-size: 2.25vh;\n\tcolor: #ffffff;\n\ttext-transform: uppercase;\n\tmargin: 10px 0;\n}\n\n\n.tittle{\n  font-weight: bold;\n}\n\n.general-page{\n  background: url('../assets/background.webp') no-repeat bottom right / auto 40vh, rgb(232, 231, 227);\n  width: 100%;\n  min-height: 100vh;\n  align-items: center;\n  justify-content: center;\n  font-family: 'Monaco', monospace;\n  position: absolute;\n  margin: 0;\n  padding: 0;\n  overflow: auto;\n  z-index: 0;\n}\n\n.general-container {\n  width: 30%;\n  margin: 5% auto;\n  padding: 30px; \n  background-color: transparent;\n  border: none;\n  text-align: center;\n}\n\n.general-input {\n  box-sizing: border-box; \n  width: 100%; \n  padding: 15px;\n  margin: 10px 0; \n  background-color: #ffffff;\n  border-radius: 10px; \n  font-family: 'Monaco', monospace;\n  color: rgb(0, 0, 0);\n  border-color: transparent;\n}\n\n.general-input-50 {\n  box-sizing: border-box;\n  width: 45%; \n  margin-right: 5%;\n  padding: 15px;\n  margin: 10px; \n  background-color: rgba(255, 255, 255,1.0);       \n  border: 0px solid #a2d2ff;\n  border-radius: 10px; \n  font-family: 'Monaco', monospace;\n}\n\n.form-container {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n}\n\n.full-width {\n  grid-column: 1 / -1;\n}\n\n.input-group {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.general-button {\n  width: 80%;\n  padding: 15px;\n  margin: 10px auto;\n  background-color: #b7f88c;\n  color: black;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: background-color 0.3s ease; \n  font-family: 'Monaco', monospace;\n}\n\n.general-button:hover {\n  background-color: #91c072;\n}\n\n.secondary-button {\n  background-color: #54f0ed;\n}\n\n.secondary-button:hover {\n  background-color: #55c9c4;\n}\n\n.fastSettings-button {\n  background-color: #ff8a99;\n}\n\n.fastSettings-button:hover {\n  background-color: #bf5a67;\n}\n\n.edit-button {\n  background-color: #ffc445;\n}\n\n.edit-button:hover {\n  background-color: #cca249;\n}\n\n.delete-button {\n  background-color: #ff2e2e;\n}\n\n.delete-button:hover {\n  background-color: #d34b4b;\n}\n\n.back-button{\n  padding: 1.5% 1.5%; \n  background-color: #ff8a99; \n  color: black; \n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: background-color 0.3s ease;\n}\n\n.back-button:hover {\n  background-color: #bf5a67;\n}\n\n.header-button {\n  padding: 2%;\n  background-color: #b7f88c;\n  color: black; \n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: background-color 0.3s ease;\n  font-family: 'Monaco', monospace\n}\n\n.header-button:hover {\n  background-color: #91c072;\n}\n\n.general-error {\n  color: #ff6961;\n  margin-bottom: 10px;\n  font-weight: bold;\n}\n\n.space-info {\n  background-color: #555;\n  color: white;\n  margin-top: 2.5%;\n  padding: 1% 0.5% 0.5% 1%;\n}\n\n.space-info-big {\n  background-color: #333;\n  color: white;\n  padding-top: 1%;\n  padding-bottom: 1%;\n  margin-top: 2.5%;\n  margin-bottom: 5%;\n  padding: 1% 0.5% 0.5% 1%;\n  border-radius: 8px;\n}\n\n.form-group {\n  position: relative;\n  margin-bottom: 20px;\n}\n\n.password-toggle-button {\n  position: absolute;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  padding: 5px;\n  cursor: pointer;\n}\n\n.little-button{\n  width: 1%;\n  margin: 1%;\n  min-width: 50px;\n}\n\n.fi-rr-pencil {\n  font-size: small;\n}\n\n.fi-rr-trash {\n  font-size: small;\n}\n\n.fi-rr-eye {\n  font-size: small;\n}\n\n.soft-background{\n  background-color: rgb(0, 0, 0, 0.0);\n}\n\n.mid-button{\n  width: 40%;\n  margin: 1%;\n}\n\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 60px;\n  height: 34px;\n}\n\n.switch input { \n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  transition: .4s;\n  border-radius: 34px;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 26px;\n  width: 26px;\n  left: 4px;\n  bottom: 4px;\n  background-color: white;\n  transition: .4s;\n  border-radius: 50%;\n}\n\ninput:checked + .slider {\n  background-color: #2196F3;\n}\n\ninput:checked + .slider:before {\n  transform: translateX(26px);\n}\n\n.help-info {\n  background-color: #333;\n  color: #fff;\n  padding: 20px;\n  border-radius: 8px;\n  overflow-x: auto;\n  text-align: center;\n}\n\n.help-container {\n  background-color: #444;\n  padding: 10px;\n  border-radius: 4px;\n  margin-bottom: 2%;\n}\n\n.sm-space-info2.centered-space-info {\n  width: 100%;\n}\n\n.content2 {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  margin-bottom: 16px;\n}\n\n.vertical-stack-content {\n    display: flex;\n    flex-direction: column;\n    min-height: 60vh;\n    justify-content: space-between;\n    flex: 1;\n}\n\n.bottom-center {\n    display: flex;\n    justify-content: center;\n    margin-top: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
